<template>
  <!-- <section v-bind:class="'show'"> -->
  <section v-bind:class="getToggleClass">
    <div class="box">
      <h3>ความคืบหน้าการเข้าเรียน</h3>
      <ul class="general-list with-progress">
        <li v-for="header in Object.keys(dashboardHeaders)" :key="header">
          <p>
            <span class="description">{{header}}</span>
            <span>{{headerPercents(header, dashboardHeaders)}}%</span>
          </p>
          <span class="progress" v-bind:style="capsuleStyle(header, dashboardHeaders)"></span>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
export default {
  computed: {
    dashboardHeaders() {
      return this.$store.getters.dashboardHeaders;
    },
    learningLecture() {
      return this.$store.getters.learningLecture;
    },
    getToggleClass() {
      return `dashboard ${this.$store.getters.getShowDashboard ? "show" : ""}`;
    },
  },
  methods: {
    headerPercents(header, dashboardHeaders) {
      const headerPercents = {};
      Object.keys(this.learningLecture).forEach((key) => {
        if (!headerPercents[this.learningLecture[key].type]) {
          headerPercents[this.learningLecture[key].type] = this.learningLecture[
            key
          ].percent;
        } else {
          headerPercents[
            this.learningLecture[key].type
          ] += this.learningLecture[key].percent;
        }
      });
      if (headerPercents[header] === undefined) return 0;
      const floatPercent =
        (headerPercents[header] * 100) / dashboardHeaders[header];
      const fixedPercent = floatPercent.toFixed(2);
      if (fixedPercent.indexOf(".00") === -1) {
        return fixedPercent;
      } else {
        return Math.trunc(floatPercent);
      }
    },
    capsuleStyle(header, dashboardHeaders) {
      return `width:${this.headerPercents(header, dashboardHeaders)}%`;
    },
  },
};
</script>